// @ts-strict-ignore
import React, { useCallback } from 'react'

import GroupedChoicePicker from 'APP/Components/GroupedChoicePicker'
import { useChoiceSearch } from 'APP/Hooks/ChoiceSearch'

import SearchCard from 'APP/Converse/SearchCard'

import type { Choice, GroupData } from 'APP/Converse/SearchCard/types'

type Props = {
  style?: object
  choices: Choice[]
  group_data: GroupData
  sendAnswer: (choice: unknown) => void
  disabled: boolean
  placeholder_text: string
  title: string
  search_source: string
}

const IntakeSearchChoice = ({
  style = {},
  choices,
  group_data,
  sendAnswer,
  disabled,
  placeholder_text,
  search_source,
}: Props) => {
  const [groups, , state] = useChoiceSearch(group_data, choices, search_source)

  const onChoicePress = useCallback(
    (choice: Choice) => {
      if (!disabled) {
        sendAnswer(choice)
      }
    },
    [disabled, sendAnswer]
  )

  const Body = (
    <GroupedChoicePicker
      groups={groups}
      disabled={disabled}
      expandGroupIndeciesOnUpdate={[]}
      onChoicePress={onChoicePress}
    />
  )

  return (
    <SearchCard
      useSemanticSearch
      style={style}
      placeholder={placeholder_text}
      disabled={disabled}
      running={state.running}
      content={Body}
      searchSource={search_source}
      groupL1Categories={group_data}
      choices={choices}
      onChoicePress={onChoicePress}
    />
  )
}

export default IntakeSearchChoice
